export default __webpack_public_path__ + "static/media/default-song.cbb4e9e4.jpg";